module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "app-screenshots@2x.fd77ed09.png" + "?" + Date.now();